var Quiz = {
	node :null,
	current: null,

	init: function() {
		Quiz.bootstrap();
	},

	bootstrap: function() {
//		Quiz.node = $("<div id='quiz' class='quiz-main'><qwin></qwin></div>");
		Quiz.node = $("<div id='quiz' class='quiz-main'><qwin ref='qwin'></qwin><questwin ref='questwin'></questwin></div>");

		$("#panels").append(Quiz.node);

		Vue.component('qwin', Quiz.qwin);
		Vue.component('questwin', Quiz.questwin);

		Quiz.vue = new Vue({
			el: '#quiz'
		});

	},

	open: function(id) {
		Quiz.vue.$refs.qwin.open(id);
	},

	quest: function(id, img, ret) {
		var first = Quiz.notfirst == undefined ? "1" : "";
		Quiz.vue.$refs.questwin.open(id, img, ret, first);
		Quiz.notfirst = 1;
	},

	placeReady: function(pe) {
	},

	process: function() {
	},

	ssi: function(className, method, params, fun) {
			
		var request = {};
						
		request.className = className;
		request.methodName = method;
						
		for(var propertyName in params) {
			request["parameters!" + propertyName] = params[propertyName];
		}
											
		$.ajax({						
			type: "POST",
			url: "/gatewayManager.php?result=json",
			dataType: "json",
			data: request
		}).done(function( resp ) {
			fun(resp);
		});
	}

}

PluginManager.add(Quiz);